// extracted by css-extract-rspack-plugin
export default {"navItemsWrapper":"nav-items-wrapper--AVEMwQpY4hE7URTj","horizontal":"horizontal--r1QwW4WirNcTIMQt"};